module.exports = __webpack_public_path__ + "img/local-food-img.6d4c999d.png";